import React from "react";
import AboutUs from "../images/ayushi-blog.jpg";

import Header from "../components/Header";
import Footer from "../components/Footer";
import Heros from "../components/Heros";
import Blog from "../components/blog/Blog";
import BlogPage from "../components/blog/BlogPage";
import { Helmet } from "react-helmet-async";

function Blogs() {
  return (
    <>
      <Helmet>
        <title>Real Estate Blog | Property Tips and Guides | Jabalpur</title>
        <meta
          name="description"
          content="Read expert articles on property buying, home loans, and real estate trends in Jabalpur. Practical guides from Ayushi Construction to help you decide smarter."
        />
        <meta
          name="keywords"
          content="property buying tips jabalpur, real estate blog jabalpur, home buying guide jabalpur"
        />
        <link rel="canonical" href="https://ayushiconstruction.com/blogslist" />
      </Helmet>

      <Heros title="Blogs" backgroundImage={AboutUs} />

      {/* <Blog /> */}
      <BlogPage />
    </>
  );
}

export default Blogs;
